import React from 'react';
import {Link } from 'react-router-dom';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import Offcanvas from 'react-bootstrap/Offcanvas';

function Navigation() {
  return (
    <>  
    
    <Navbar expand='md' >
      
      <Navbar.Brand href={process.env.PUBLIC_URL}><img src={process.env.PUBLIC_URL+'/assets/logo.png'}/></Navbar.Brand>
        <Navbar.Toggle aria-controls={`offcanvasNavbar-expand-md`} />
        <Navbar.Offcanvas
          id={`offcanvasNavbar-expand-md`}
          aria-labelledby={`offcanvasNavbarLabel-expand-md`}
          placement="end">
          <Offcanvas.Header closeButton>
            <Offcanvas.Title id={`offcanvasNavbarLabel-expand-md`}>
             
            </Offcanvas.Title>
          </Offcanvas.Header>
          <Offcanvas.Body>
            <Nav  className=" flex-grow-1 pe-3 center">
               <Link to='/list'>Admin</Link> 
              <Link to='/'>Edit Account Info</Link>
              <Link to='/'>Change Password</Link>
              <Link to='/'>Logout</Link>  
            </Nav> 
          </Offcanvas.Body>
        </Navbar.Offcanvas>
    </Navbar>
  
</>
  );
}

export default Navigation;